var render = function render(){var _vm=this,_c=_vm._self._c;return _c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.fieldValue),expression:"fieldValue"}],class:_vm.options.css_classes,attrs:{"id":'field-' + _vm.options.id,"name":'field-' + _vm.options.id},domProps:{"value":(_vm.fieldValue)},on:{"input":function($event){if($event.target.composing)return;_vm.fieldValue=$event.target.value}}})
}
var staticRenderFns = []

export { render, staticRenderFns }